<script lang="ts">
  import { createEventDispatcher } from "svelte"
  import { Trash } from "lucide-svelte"

  export let user: any
  export let roles: any

  const dispatch = createEventDispatcher()

  let errors: any = {}

  const emailRegex =
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/

  export function validate(): boolean {
    if (user.id) return true

    errors = {}
    if (!user.name) {
      errors.name = "Name is required"
    }
    if (!errors.name && user?.name.trim().length < 3) {
      errors.name = "Name must be at least 3 characters"
    }
    if (!user.email) {
      errors.email = "Email is required"
    }
    if (!!user.email && !emailRegex.test(user.email)) {
      errors.email = "Email is invalid"
    }

    if (!user.role || !Object.keys(roles).includes(user.role)) {
      errors.role = "Invalid role"
    }

    return Object.keys(errors).length === 0
  }
</script>

<div class="mt-2 gap-y-4 gap-x-1 user-row" data-name="line">
  <div class="1-fr">
    <div class="input-cont" class:error={errors.name}>
      <input
        bind:value={user.name}
        type="text"
        data-name="name"
        class="input input-lg"
        readonly={user.id}
        class:bg-gray-200={user.id}
      />
      <div class="msg">
        {errors.name || ""}
      </div>
    </div>
  </div>
  <div class="1-fr">
    <div class="input-cont" class:error={errors.email}>
      <input
        bind:value={user.email}
        type="email"
        data-name="email"
        class="input input-lg"
        class:bg-gray-200={user.id}
        readonly={user.id}
      />
      <div class="msg">
        {errors.email || ""}
      </div>
    </div>
  </div>
  <div class="1-fr">
    <div class="input-cont" class:error={errors.role}>
      {#if user.id}
        <input
          type="text"
          value={roles[user.role]}
          class="input input-lg bg-gray-200"
          class:font-bold={user.role === "admin"}
          readonly
        />
      {:else}
        <select bind:value={user.role} class="input input-lg" data-name="role">
          {#each Object.keys(roles) as key}
            <option value={key}>{roles[key]}</option>
          {/each}
        </select>
      {/if}
    </div>
  </div>

  <div class="flex items-center">
    <button
      class="text-red-400 hover:text-red-500"
      on:click={() => dispatch("delete")}
      class:hidden={user.id}
      type="button"
    >
      <Trash class="w-8 h-8 ml-1" />
    </button>
  </div>
</div>

<style lang="postcss">
  .user-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 3rem;
  }
</style>
